<template>
  <v-card :class="{ dark }" elevation="0" width="100%" id="bulb-assignments">
    <v-list class="branded-background" v-if="!embedded">
      <v-list-tile avatar>
        <v-list-tile-avatar>
          <v-icon color="white">info</v-icon>
        </v-list-tile-avatar>
        <v-list-tile-content>
          <v-list-tile-title>
            <span class="text-white">Bulb Details</span>
          </v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
    </v-list>
    <div v-if="ltiLaunchUrl" class="pt-3">
      <h3 class="px-4"><strong>LTI Launch URL:</strong></h3>
      <div class="copy-container">
       <v-text-field  box hide-details readonly :value="ltiLaunchUrl"></v-text-field><ClipboardCopy :copyText="ltiLaunchUrl"></ClipboardCopy>
      </div>
    </div>
    <div v-if="!instructorAjaxing && bulbSections.length > 0">
      <div class="log-header">
        <span class="log-column-header">Class</span>
        <span class="log-column-header">Assigned Date</span>
        <span class="log-column-header">Archived</span>
      </div>
      <v-divider :color="[dark ? 'white' : '#808080' ]" class="mb-4 mx-4"></v-divider>
      <ul class="log-data">
        <li v-for="bs in bulbSections" :key="bs.id">
          <span>{{bs.name}}</span>
          <span>{{bs.created}}</span>
          <span>{{bs.archived}}</span>
        </li>
      </ul>
    </div>
    <h2 v-if="!instructorAjaxing && bulbSections.length === 0" class='text-xs-center' style="padding-top: 24px;">Bulb not assigned to any class</h2>
    <v-expansion-panel
      :dark="dark"
      class="px-2 pt-2"
      v-if="showBulbActivity">
      <v-expansion-panel-content>
        <template v-slot:header>
          <div>Bulb Activity</div>
        </template>
        <v-card>
          <div id="bulbActivityBox">
            <v-list
              two-line>
              <v-list-tile v-if="bulbActivity.length === 0">
                <v-list-tile-content>
                  <v-list-tile-title>No bulb activity</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
              <v-list-tile v-else v-for="item in bulbActivity" :key="item.id">
                <v-list-tile-content>
                  <v-list-tile-title v-text="item.description"></v-list-tile-title>
                  <v-list-tile-sub-title>{{ bulbActivitySubTitle(item) }}</v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </div>
        </v-card>
      </v-expansion-panel-content>
    </v-expansion-panel>
    <v-container v-if="instructorAjaxing" class="loader-popover">
      <v-progress-circular indeterminate size=50 :width="5"></v-progress-circular>
    </v-container>
    <v-card-actions v-if="!embedded" class="row-space">
      <v-btn flat class="branded-grey" @click="setDashModal(null)">Close</v-btn>
    </v-card-actions>
  </v-card>

</template>

<script>
/* global _ */
/* global moment */
import { mapGetters, mapMutations, mapActions, mapState } from 'vuex';
import ClipboardCopy from '@/components/buttons/clipboardCopy';
import _ from 'lodash';

export default {
  name: 'BulbAssignments',
  components: { 
    ClipboardCopy,
  },
  props: [ 
    'admin',
    'bulbId',
    'dark',
    'embedded',
    'hideLtiLaunch',
  ], 
  data() {
    return {
      bulbActivity: [],
      bulbSections: [ ],
    };
  },
  computed: {
    ...mapGetters([
      'school'
    ]),
    ...mapGetters('instructors', [
      'instructorAjaxing',  
    ]),
    ltiLaunchUrl() {
      // Tellall, render lti path
      if (this.school && [12, 1556].includes(this.school.id) && !this.hideLtiLaunch) {
        return `https://www.playposit.com/LTI/launch/${this.bulbId}/play2`;
      }
      return '';
    },
    showBulbActivity() {
      return _.get(this.school, 'config.permissions', []).includes('enableBulbAuditLogs');
    },
  },
  methods: {
    ...mapMutations([
      'setDashModal'
    ]),
    ...mapActions('admin', {
      adminGetBulbSections: 'getBulbSections',
    }),
    ...mapActions('instructors', {
      instructorGetBulbSections: 'getBulbSections',
      getBulbActivity: 'getBulbActivity',
    }),
    bulbActivitySubTitle(item) {
      const timestampDate = new Date(item.timestamp);
      const options = {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: '2-digit',
        minute:'2-digit',
      };
      return `${item.teacher.email} - ${timestampDate.toLocaleString("en-US", options)}`;
    },
  },
  async mounted() {
    this.bulbSections =  this.admin ? await this.adminGetBulbSections(this.bulbId) : await this.instructorGetBulbSections(this.bulbId);
    if (this.showBulbActivity) this.bulbActivity = await this.getBulbActivity(this.bulbId);
  },
};
</script>

<style>

#bulb-assignments.dark {
  background-color: #383838 !important;
}

.dark i, 
.dark span, 
.dark div
.dark h1,
.dark h2,
.dark h3 {
  color: #FFF !important;
  
}

.log-header, .log-data li {
  display: flex;
}
.log-header {
  padding: 24px 24px 0px 24px;
}
.log-column-header {
  list-style-type: none;
  flex: 1 1;
}
.log-data {
  padding: 0px 24px 24px 24px;
  max-height: 500px;
  overflow: auto;
}
.log-data li span {
  flex: 1 1;
}
#bulbActivityBox {
  max-height: 300px;
  overflow: auto;
}
  
</style>
